import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Modal, message } from "antd";
import moment from "moment";
import jsPDF from "jspdf";
import { CSVLink } from "react-csv";
import { useParams, useLocation } from "react-router-dom";
import {
  reload,
  loadPage,
  reset as resetPage,
  sendDiaries,
  setTextFilter,
  exportEmployees,
} from "../EmployeesSlice";
import {
  listBranchWorkDiaries,
  generateImmigrationFile,
  exportEmployees as exportEmployeesApi,
} from "../../../api/server";
import { isEmployeeActive } from "../../employeeDetails/employeeDetailsSlice";
import ActionsTable from "../../../components/templates/ActionsTable";
import EmployeeBranches from "../../../components/tables/EmployeeBranches";
import NewEmployeeWizard from "../newEmployee/NewEmployeeWizard";
import { ReactComponent as EmployeesImg } from "../../../assets/no-employees.svg";
import { reset, loadRecord } from "../../employeeDetails/employeeDetailsSlice";
import { reset as resetScheduling } from "../../employeeScheduling/schedulingSlice";
import EmployeeCard from "../employeeCard";
import AssignEmployee from "./AssignEmployee";
import ApprovalModal from "./ApprovalModal";
import DiariesModal from "./DiariesModal";
import HistoryModal from "../scheduling/HistoryModal";
import ReplacementsModal from "../replacements/ReplacementsModal";
import UploadImmigrationFile from "./UploadImmigrationFile";
import PrintDiariesModal from "./PrintDiariesModal";
import SendDiariesModal from "./SendDiariesModal";
import PrintFormsModal from "../../../components/companyforms/PrintFormsModal";
import { getColumns } from "./EmployeeTableItems";
import { openURL, getDiary, loadImage } from "../../../components/util/helpers";
import { useUserBranches } from "../../../hooks/accessControl";
import useDebounce from "../../../components/util/useDebounce";
import { isAllowedFeature } from "../../organization/organizationSlice";
import MonthAndBranchesModal from "../../../components/templates/MonthAndBranchesModal";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import ExportErrorsModal from "./ExportErrorsModal";

const EmployeesList = ({ activeTab }) => {
  const dispatch = useDispatch();
  const userBranches = useUserBranches();
  const intl = useIntl();
  const location = useLocation();
  const { branchId } = useParams();
  const [visible, setVisible] = useState(false);
  const [showScheduling, setShowScheduling] = useState(false);
  const [assignVisible, setAssignVisible] = useState(false);
  const [employeeCardVisible, setEmployeeCardVisible] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [approvalModalVisible, setApprovalModalVisible] = useState(false);
  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [replacementsModalVisible, setReplacementsModalVisible] =
    useState(false);
  const [diariesModalVisible, setDiariesModalVisible] = useState(false);
  const [uploadVisible, setUploadVisible] = useState(false);
  const [printDiariesVisible, setPrintDiariesVisible] = useState(false);
  const [sendDiariesVisible, setSendDiariesVisible] = useState(false);
  const [exportEmployeesVisible, setExportEmployeesVisible] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [branchName, setBranchName] = useState("");
  const [printDiariesValues, setPrintDiariesValues] = useState({});
  const [triggerQueryTimestamp, setTriggerQueryTimestamp] = useState(null);
  const [formsModalEmployee, setFormsModalEmployee] = useState(null);
  const [exportErrors, setExportErrors] = useState(null);
  const [errorsModalVisible, setErrorsModalVisible] = useState(false);
  const [exportHargalLoading, setExportHargalLoading] = useState(false);
  const { page: employeesPage } = useSelector((state) => state.employees);
  const { current, pageSize, total, items, filter, order } = employeesPage;
  const loading = useSelector(
    (state) => state.pendingActions["employees/loadPage"]
  );
  const exportLoading = useSelector(
    (state) => state.pendingActions["employees/export"]
  );
  const isAdmin = location.pathname.includes("admin");
  const organization = useSelector((state) => state.organization.details);
  const debouncedSearch = useDebounce(filter.freeText, 400);
  const employee_export_type = organization?.employee_export_type;
  const isHargalInterface = employee_export_type === "הר-גל ממשק";
  useEffect(() => {
    if (activeTab === "employees_list") {
      dispatch(loadPage({ current: 1, filter, order, pageSize }));
    }
  }, [activeTab, dispatch]);

  useEffect(() => {
    const branch = userBranches.find((i) => i.id === +branchId);
    if (branch) {
      setBranchName(branch.name);
    }
  }, [userBranches, branchId]);

  const handleMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        onShowEmployeeCardClicked(record, true);
        break;
      case "2":
        onlaunchApprovalModal(record);
        break;
      case "3":
        onLaunchHistoryModal(record);
        break;
      case "4":
        onLaunchReplacementsModal(record);
        break;
      case "5":
        onlaunchDiariesModal(record);
        break;
      case "6":
        onlaunchFormsModal(record);
        break;
      default:
        break;
    }
  };

  const handleAdminMenuClick = (e, record) => {
    switch (e.key) {
      case "1":
        onShowEmployeeCardClicked(record, true);
        break;
      case "2":
        onAssignClicked(record);
        break;
      case "3":
        onlaunchApprovalModal(record);
        break;
      case "4":
        onLaunchHistoryModal(record);
        break;
      case "5":
        onLaunchReplacementsModal(record);
        break;
      case "6":
        onlaunchDiariesModal(record);
        break;
      case "7":
        onlaunchFormsModal(record);
        break;
      default:
        break;
    }
  };

  const handleAdminEmployeesMenuClick = (e) => {
    switch (e.key) {
      case "1":
        handleUploadImmigrationFile();
        break;
      case "2":
        handleExportImmigrationFile();
        break;
      case "3":
        handlePrintDiaries();
        break;
      case "4":
        handleEmployeesExport();
        break;
      default:
        break;
    }
  };

  const handleBranchEmployeesMenuClick = (e) => {
    switch (e.key) {
      case "1":
        handlePrintDiaries();
        break;
      case "2":
        handleSendDiaries();
        break;
      case "3":
        handleEmployeesExport();
        break;
      default:
        break;
    }
  };

  const getEmployee = (id) => {
    const isAdmin = location.pathname.includes("admin");
    const params = {
      id,
      branchId,
      admin: isAdmin,
    };
    dispatch(loadRecord(params));
  };

  const onShowEmployeeCardClicked = (record, show) => {
    setSelectedEmployee(record);
    setEmployeeCardVisible(true);
    setShowScheduling(show);
    if (show) {
      getEmployee(record.id);
    }
  };

  const onHideEmployeeCardModal = () => {
    setEmployeeCardVisible(false);
    dispatch(reset());
  };

  const onAssignClicked = (record) => {
    setAssignVisible(true);
    setSelectedEmployee(record);
  };

  const hideAssign = () => {
    setAssignVisible(false);
    setSelectedEmployee(null);
    dispatch(reload());
  };

  useEffect(() => {
    dispatch(
      loadPage({
        current: 1,
        filter: { ...filter, freeText: debouncedSearch },
        order,
        pageSize,
      })
    );
  }, [dispatch, debouncedSearch]);

  const onTextChange = (e) => {
    dispatch(setTextFilter({ text: e.target.value }));
  };

  const onAddClick = () => {
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const onHideApprovalModal = () => {
    setApprovalModalVisible(false);
    dispatch(resetScheduling());
  };

  const onlaunchApprovalModal = (record) => {
    getEmployee(record.id);
    setApprovalModalVisible(true);
  };

  const onLaunchHistoryModal = (record) => {
    getEmployee(record.id);
    setHistoryModalVisible(true);
  };

  const onHideHistoryModal = () => {
    setHistoryModalVisible(false);
  };

  const onLaunchReplacementsModal = (record) => {
    getEmployee(record.id);
    setReplacementsModalVisible(true);
  };

  const onHideReplacementsModal = () => {
    setReplacementsModalVisible(false);
  };

  const onlaunchDiariesModal = (record) => {
    getEmployee(record.id);
    setDiariesModalVisible(true);
  };

  const onHideDiariesModal = () => {
    setDiariesModalVisible(false);
    dispatch(resetScheduling());
  };

  const onlaunchFormsModal = (record) => {
    setFormsModalEmployee(record.id);
  };

  const onHideFormsModal = () => {
    setFormsModalEmployee(null);
  };

  const handlePrintDiaries = () => {
    setPrintDiariesVisible(true);
  };

  const hidePrintDiaries = () => {
    setPrintDiariesVisible(false);
    setPrintDiariesValues({});
  };

  const handleSendDiaries = () => {
    setSendDiariesVisible(true);
  };

  const hideSendDiaries = () => {
    setSendDiariesVisible(false);
  };

  const onSendDiaries = async (values) => {
    const month = values.month ? +moment(values.month).format("M") : null;
    const year = values.month ? +moment(values.month).format("YYYY") : null;
    const params = {
      month,
      year,
      exclude_presense_reporting_clients:
        values.exclude_presense_reporting_clients,
    };

    setSendLoading(true);
    const action = await dispatch(sendDiaries({ branchId, params }));
    if (!action.error) {
      setSendLoading(false);
      hideSendDiaries();
    } else {
      setSendLoading(false);
    }
  };

  const onPrintDiaries = async (values) => {
    const { branches, diaries_export_type, staff_worker_in_charge_id } = values;
    const params = {
      branchId: branchId || branches,
      query: {
        from: moment(values.month).startOf("month").format(),
        to: moment(values.month).endOf("month").format(),
        diaries_export_type: diaries_export_type || "all",
        staff_worker_in_charge_id,
        exclude_presense_reporting_clients:
          values.exclude_presense_reporting_clients,
      },
    };

    setPrintLoading(true);
    const action = await listBranchWorkDiaries(params);
    if (!action.error && action.data.items) {
      onPrintAll(action.data.items, values.month);
    } else {
      setPrintLoading(false);
      hidePrintDiaries();
    }
  };

  const handleUploadImmigrationFile = () => {
    setUploadVisible(true);
  };

  const hideUpload = () => {
    setUploadVisible(false);
  };

  const handleExportImmigrationFile = async () => {
    const action = await generateImmigrationFile();
    openURL(action.file_url);
  };

  const handleEmployeesExport = () => {
    setExportEmployeesVisible(true);
  };

  const hideEmployeesExport = () => {
    setExportEmployeesVisible(false);
  };

  const onExportEmployees = async (values) => {
    const data = {
      branchId: +branchId,
      params: {
        year: +moment(values.month).format("YYYY"),
        month: +moment(values.month).format("M"),
        branch_ids: values.all_branches ? null : values.branches,
        incremental: values.incremental,
      },
    };

    if (isHargalInterface) {
      try {
        setExportHargalLoading(true);
        const action = await exportEmployeesApi(data);
        const payload = action.data;
        setExportHargalLoading(false);
        hideEmployeesExport();
        if (payload.errors && payload.errors.length > 0) {
          setExportErrors(payload.errors);
          setErrorsModalVisible(true);
        } else if (!action.error) {
          message.success(
            intl.formatMessage({
              id: "app.notifications.export_employees_success",
            })
          );
        }
      } catch (error) {
        setExportHargalLoading(false);
        message.error(
          intl.formatMessage({ id: "app.notifications.export_employees_error" })
        );
      }
    } else {
      const action = await dispatch(exportEmployees(data));
      if (!action.error) {
        hideEmployeesExport();
        openURL(action.payload.data.file_url);
      }
    }
  };

  const handleCloseErrorsModal = () => {
    setErrorsModalVisible(false);
  };

  const ExportAdditionalItems = () => (
    <AnimationChildWrapper itemKey={3}>
      <CheckBoxItem showLabel={true} name="incremental" category="component" />
    </AnimationChildWrapper>
  );

  const adminDropDownItems = [
    {
      label: intl.formatMessage({
        id: "app.employees.recieveImmigrationFile",
      }),
      key: "1",
    },
    {
      label: intl.formatMessage({
        id: "app.employees.downloadImmigrationFile",
      }),
      key: "2",
    },
    {
      label: intl.formatMessage({ id: "app.employees.printDiaries" }),
      key: "3",
    },
    {
      label: intl.formatMessage({ id: "app.employees.export_employees" }),
      key: "4",
    },
  ];

  const adminDropDownMenu = {
    items: adminDropDownItems,
    onClick: (e) => handleAdminEmployeesMenuClick(e),
  };

  const branchDropDownItems = [
    {
      label: intl.formatMessage({ id: "app.employees.printDiaries" }),
      key: "1",
    },
    {
      label: intl.formatMessage({ id: "app.employees.sendDiaries" }),
      key: "2",
    },
    {
      label: intl.formatMessage({ id: "app.employees.export_employees" }),
      key: "3",
    },
  ];

  const branchDropDownMenu = {
    items: branchDropDownItems,
    onClick: (e) => handleBranchEmployeesMenuClick(e),
  };

  const triggerFetch = (timestamp) => {
    setTriggerQueryTimestamp(timestamp);
  };

  const onPrintAll = async (items, currentDate) => {
    if (!items || items.length === 0) return;
    const avatar_url = organization.avatar_url;
    const logo = await loadImage(avatar_url);
    const diariesPdf = new jsPDF({ orientation: "p" });

    let modifiedItems;
    if (printDiariesValues?.is_empty) {
      // Take only the first item when printing an empty diary
      const firstItem = items[0];
      modifiedItems = [
        {
          holidays: firstItem.holidays,
          manual_events: [],
          recurrent_work_events: [],
          scheduled_recurrent_events: [],
          patient: { branch: firstItem.patient?.branch },
        },
      ];
    } else {
      modifiedItems = items;
    }

    modifiedItems.forEach((item, index) => {
      if (index > 0) {
        diariesPdf.addPage();
      }
      getDiary(diariesPdf, intl, item, organization, currentDate, logo);
    });

    setPrintLoading(false);
    hidePrintDiaries();
    window.open(diariesPdf.output("bloburl"), "_blank");
  };

  const columns = getColumns(
    isAdmin,
    intl,
    handleAdminMenuClick,
    handleMenuClick,
    userBranches,
    EmployeeBranches,
    isAllowedFeature
  );

  const triggerQuery = (order) => {
    dispatch(loadPage({ current: 1, filter, order, pageSize }));
  };
  return (
    <div>
      <ActionsTable
        checkActive={isEmployeeActive}
        tableItems={columns}
        ltrItems={["contact_info.mobile_number"]}
        category="employees"
        order={order}
        resource="employees"
        current={current}
        pageSize={pageSize}
        total={total}
        filtersType={{
          employee_type_id: "number",
          gender_id: "number",
          status: "number",
        }}
        paramsFilters={["branches"]}
        loading={loading}
        textFilter={filter.freeText}
        reload={reload}
        loadPage={loadPage}
        resetPage={resetPage}
        items={items}
        onTextChange={onTextChange}
        onAddClick={onAddClick}
        dropDownMenu={branchId ? branchDropDownMenu : adminDropDownMenu}
        addbuttonText={intl.formatMessage({
          id: "app.employees.addNewEmployee",
        })}
        headerInputPlaceholder={intl.formatMessage({
          id: "app.employees.typeEmployeeName",
        })}
        autoFocus={true}
        showheader={true}
        emptyImage={<EmployeesImg />}
        emptytext={intl.formatMessage({ id: "app.tables.noEmployees" })}
        skipInitialLoad={true}
        triggerQuery={triggerQuery}
      />
      <Modal
        closable={false}
        maskClosable={false}
        footer={null}
        width={"820px"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        title={null}
        open={visible}
        onCancel={hide}
        destroyOnClose={true}
      >
        <NewEmployeeWizard
          hideWizard={hide}
          onShowEmployeeCardClicked={onShowEmployeeCardClicked}
        />
      </Modal>
      <EmployeeCard
        record={selectedEmployee}
        onHide={onHideEmployeeCardModal}
        visible={employeeCardVisible}
        showScheduling={showScheduling}
      />
      <AssignEmployee
        visible={assignVisible}
        hide={hideAssign}
        record={selectedEmployee}
      />
      <ApprovalModal
        onHide={onHideApprovalModal}
        visible={approvalModalVisible}
      />
      <DiariesModal onHide={onHideDiariesModal} visible={diariesModalVisible} />
      <HistoryModal onHide={onHideHistoryModal} visible={historyModalVisible} />
      <ReplacementsModal
        onHide={onHideReplacementsModal}
        visible={replacementsModalVisible}
        title={intl.formatMessage({ id: "app.scheduling.replacementsTitle" })}
        subTitle={intl.formatMessage({
          id: "app.scheduling.replacementsSubTitle",
        })}
        triggerFetch={triggerFetch}
        triggerQueryTimestamp={triggerQueryTimestamp}
      />
      <UploadImmigrationFile visible={uploadVisible} hide={hideUpload} />
      <PrintDiariesModal
        branchId={branchId}
        printDiariesVisible={printDiariesVisible}
        hidePrintDiaries={hidePrintDiaries}
        branchName={branchName}
        onPrintDiaries={onPrintDiaries}
        printLoading={printLoading}
        printDiariesValues={printDiariesValues}
        setPrintDiariesValues={setPrintDiariesValues}
      />
      <SendDiariesModal
        branchId={branchId}
        hideSendDiaries={hideSendDiaries}
        sendDiariesVisible={sendDiariesVisible}
        branchName={branchName}
        onSendDiaries={onSendDiaries}
        sendLoading={sendLoading}
      />
      <PrintFormsModal
        visible={formsModalEmployee}
        onCancel={onHideFormsModal}
        entityCollection="employees"
        entity="employee"
        entityId={formsModalEmployee}
      />
      <MonthAndBranchesModal
        onHide={hideEmployeesExport}
        visible={exportEmployeesVisible}
        title={
          !branchId
            ? intl.formatMessage({
                id: "app.employees.export_employees",
              })
            : `${intl.formatMessage({
                id: "app.employees.export_employees_for_branch",
              })} ${branchName}`
        }
        btnText={intl.formatMessage({
          id: "app.actions.export",
        })}
        onSubmit={onExportEmployees}
        branchId={+branchId}
        loading={exportLoading || exportHargalLoading}
        additionaItems={<ExportAdditionalItems />}
        initialValues={{
          month: moment(),
          branches: branchId ? +branchId : null,
        }}
      />
      <ExportErrorsModal
        visible={errorsModalVisible}
        onClose={handleCloseErrorsModal}
        errors={exportErrors}
      />
    </div>
  );
};

export default EmployeesList;
